import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
  'libraries.list.actions': {
    defaultMessage: 'Actions',
    id: 'libraries.list.actions'
  },
  'libraries.list.actions.publish.areYouSure': {
    defaultMessage: 'Are you sure you want to publish the library "<b>{displayName}</b>"?',
    id: 'libraries.publish.areYouSure'
  },
  'libraries.list.actions.publish.modalTitle': {
    defaultMessage: 'Publish Library?',
    id: 'libraries.actions.publish.modalTitle'
  },
  'libraries.list.created': {
    defaultMessage: 'Created',
    id: 'libraries.list.created'
  },
  'libraries.list.description': {
    defaultMessage: 'Description',
    id: 'libraries.list.description'
  },
  'libraries.list.displayedRows': {
    defaultMessage: '{from, number}-{to, plural, =-1 {{count, number}} other {#}} of {count, plural, =-1 {more than {to, number}} other {#}}',
    id: 'libraries.list.displayedRows'
  },
  'libraries.list.empty.action': {
    defaultMessage: 'Create a library',
    id: 'libraries.list.empty.action'
  },
  'libraries.list.empty.primary': {
    defaultMessage: 'No libraries',
    id: 'libraries.list.empty.primary'
  },
  'libraries.list.empty.secondary': {
    defaultMessage: 'Your account has no libraries yet.',
    id: 'libraries.list.empty.secondary'
  },
  'libraries.list.failed': {
    defaultMessage: 'Failed to load libraries',
    id: 'libraries.list.failed'
  },
  'libraries.list.loading': {
    defaultMessage: 'Loading...',
    id: 'libraries.list.loading'
  },
  'libraries.list.name': {
    defaultMessage: 'Name',
    id: 'libraries.list.name'
  },
  'libraries.list.publish': {
    defaultMessage: 'Publish',
    id: 'libraries.list.publish'
  },
  'libraries.list.publish.failure': {
    defaultMessage: 'Failed to publish library',
    id: 'libraries.list.publish.failure'
  },
  'libraries.list.publish.failure.noChildren': {
    defaultMessage: 'Failed to publish library - Your account has no related customers',
    id: 'NO_CHILDREN'
  },
  'libraries.list.publish.success': {
    defaultMessage: 'Library published successfully',
    id: 'libraries.list.publish.success'
  },
  'libraries.list.published': {
    defaultMessage: 'Published',
    id: 'libraries.list.published'
  },
  'libraries.list.published.last': {
    defaultMessage: 'Last published: {date}',
    id: 'libraries.list.published.last'
  },
  'libraries.list.published.never': {
    defaultMessage: 'Never published',
    id: 'libraries.list.published.never'
  },
  'libraries.list.rowsPerPage': {
    defaultMessage: 'Rows per page',
    id: 'libraries.list.rowsPerPage'
  },
  'libraries.list.status': {
    defaultMessage: 'Status',
    id: 'libraries.list.status'
  },
  'libraries.list.unpublished': {
    defaultMessage: 'Unpublished',
    id: 'libraries.list.unpublished'
  },
  'libraries.list.unpublished.pending': {
    defaultMessage: 'Changes pending',
    id: 'libraries.list.unpublished.pending'
  },
  'libraries.list.update': {
    defaultMessage: 'Update',
    id: 'libraries.list.update'
  },
  'libraries.list.updated': {
    defaultMessage: 'Updated',
    id: 'libraries.list.updated'
  }
});
